import { gsap } from 'gsap/all'

export class Reveal {
  constructor (element, type) {
    this.element = element
    this.type = type
  }

  reveal () {
    if (this.type === 'lines' || this.type === 'words') {
      this.revealLines()
    } else if (this.type === 'up') {
      this.revealUps()
    } else if (this.type === 'staggerUp') {
      this.revealStaggerUps()
    }
  }

  revealUps () {
    gsap.to(this.element, 0.5, {
      opacity: 1,
      y: 0,
      delay: 0.15,
      ease: 'power4.out'
    })
  }

  revealStaggerUps () {
    gsap.to(this.element.children, 0.75, {
      opacity: 1,
      stagger: 0.05,
      delay: 0.15,
      y: 0,
      ease: 'power4.out',
      onStart: () => {
        this.element.style.opacity = 1
      }
    })
  }

  revealLines () {
    this.element.style.opacity = 1

    this.lines = []

    if (this.element.querySelector('.line-wrapper')) {
      this.lines = [...this.element.querySelectorAll('.line-wrapper div')]
    } else {
      this.lines = [...this.element.querySelectorAll('.word-wrapper div')]
    }

    this.lines.forEach(line => { line.style.willChange = 'transform' })

    gsap.set(this.lines, { y: '125%' })

    gsap.to(this.lines, 0.75, {
      y: '0%',
      ease: 'expo.out',
      stagger: 0.05,
      delay: 0.1,
      onComplete: () => {
        this.lines.forEach(line => { line.style.willChange = 'unset' })
      }
    })
  }
}
